import InterviewCard from './InterviewCard.vue';

export default InterviewCard;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/cards/InterviewCard/index.ts